const proto = "https";
const domain = "www.mahjong-jp.com/sgtest";
const pureUrl = `${proto}://${domain}`;
export const shareConfig = {
  url: encodeURIComponent(pureUrl),
  domain: domain,
  pureUrl: pureUrl,
  url_cn: encodeURIComponent("https://www.lizhimahjong.com/sgtest"),
  tag_1: "sgtest_bg.p58",
  tag_2: "sgtest_bg.p59",
  tag_3: "sgtest_bg.p60",
  // via: "", // Twitter account 未使用该参数
};
